/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnEdward.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnEdward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnEdward-view">
        <Helmet>
          <title>Founders - Edward Lai - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnEdward-first">
          <Link to="/EnTeam">
            <div className="EnEdward-back">
              <div className="EnEdward-backBtn"></div>
              <div className="EnEdward-backText">Back</div>
            </div>
          </Link>

          <div className="EnEdwardContainer">
            <div className="EnEdward-edwardPic" />

            <div className="EnEdward-name">
              <strong>Edward Lai</strong>
              <br />
              Founder, CEO and Chief Design Officer
            </div>
          </div>
        </div>

        <div className="EnEdward-second">
          <div className="EnEdward-secondText">
            Edward Lai is the Founder, CEO and Chief Design Officer of
            CheckPlus.
            <p />
            Before being the Founder, CEO and Chief Design Officer of CheckPlus,
            Edward used to live and study in Australia and the United States. He
            decided moving back to Hong Kong to contribute with the knowledge
            and skills he has gained over the years.
            <p />
            Edward devotes most of his time working closly with many nonprofits
            in Hong Kong, and he hopes to give back to the local community by
            providing technology solutions to nonprofits with CheckPlus.
            <p />
            In 2019, he has met with many nonprofits in Hong Kong and CheckPlus
            has been recognized as an easy-to-use online donation platform and
            is in-use by 30+ nonprofit organizations.
            <p />
            Edward earned a Bachelor of Art in Sociology from the University of
            California, Santa Barbara.
          </div>
        </div>

        <div className="EnEdward-footer">
          <div className="EnEdward-footerNav">
            <Link to="/EnTeam">
              <div className="EnEdward-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnEdward-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnEdward-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnEdward-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnEdward-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnEdward;
